import React from "react";
import ProductRackCell from "./ProductRackCell";
export default function ProductListItem(props) {
  const showPlace = (line) => {
    if (!line.rack && !line.cell) {
      return <i className="fa fa-ellipsis-h"></i>;
    }
    return (
      <div className="small">
        <ProductRackCell {...line} />
      </div>
    );
  };

  const pick = props.onProductPick ? true : false;

  return (
    <>
      <div
        onDoubleClick={() => {
          if (pick) {
            props.onProductPick(props);
          }
        }}
        className={`row py-4 border-bottom ${pick && "bg-hover-light"}`}
      >
        <div className={pick ? "col-5" : "col-7"}>
          {!pick ? (
            <div
              className="cursor-pointer text-hover-primary  "
              onClick={() => props.onInfoOpen(props.id, props)}
            >
              {props.label}
            </div>
          ) : (
            <span> {props.label}</span>
          )}
        </div>

        <div className="col">
          <div
            className="cursor-pointer text-hover-primary"
            onClick={() => props.onPlaceOpen(props.id, props)}
          >
            {showPlace(props)}
          </div>
        </div>
        <div className="col">
          <div
            className="cursor-pointer text-hover-primary"
            onClick={() => props.onTurnoverOpen(props.id, props)}
          >
            {props.balance}{" "}
            <span className="text-muted small">{props.measurename}</span>
          </div>
        </div>
        <div className="col">
          <div className="d-flex align-items-center">
            <div className="flex-grow-1">
              {props.price}{" "}
              <span className="text-muted small">{props.currencyname}</span>
            </div>

            {pick ? (
              <i
                onClick={() => props.onProductPick(props)}
                className="ml-2 fa fa-check text-muted text-hover-primary cursor-pointer"
                title="Выбрать"
              ></i>
            ) : (
              <i
                onClick={() => props.onCartAdd(props.id)}
                className="ml-2 fa fa-cart-plus text-muted text-hover-primary cursor-pointer"
                title="Добавить в подборку"
              ></i>
            )}
          </div>
        </div>
      </div>
    </>
  );
}
